import bannerImage from "../../../../assets/images/ads/banner_img.png";
import bannerDecor from "../../../../assets/images/ads/banner_decor_image.png";
import lumiAds from "../../../../assets/images/ads/lumi_ads.png";
import laptopImage from "../../../../assets/images/ads/laptop_image.png";
import adsIcon1 from "../../../../assets/images/ads/ads_icon1.png";
import adsIcon2 from "../../../../assets/images/ads/ads_icon2.png";
import adsIcon3 from "../../../../assets/images/ads/ads_icon3.png";
import adsIcon4 from "../../../../assets/images/ads/ads_icon4.png";
import adsIcon5 from "../../../../assets/images/ads/ads_icon5.png";
import adsIcon6 from "../../../../assets/images/ads/ads_icon6.png";
import adsDecor from "../../../../assets/images/ads/decor2.png";
import whyLumiAdsDecor from "../../../../assets/images/ads/decor3.png";
import bgImage from "../../../../assets/images/ads/bg_light_img.png";

const hostname = window.location.hostname;
let adsSite = "";
// switch (hostname) {
//     case "localhost":
//         adsSite = "https://adsuat.lumimatrimony.com";
//         break;
//     case "webdev.lumimatrimony.com":
//         adsSite = "https://adsuat.lumimatrimony.com";
//         break;
//     case "lumimatrimony.com":
//         adsSite = "https://ads.lumimatrimony.com";
//         break;
//     default:
//         break;
// }

export const data = {
    header: {
        logo: "lumi-ads-logo.png",
        signIn : {
            label: 'Sign In',
            href: `/login/signin`,
        },
        navLinks: [{
                label: "Home",
                href: "#home",
                status: true,
                customScroll: true
            },
            {
                label: "Features",
                href: "#features",
                customScroll: true
            },
            {
                label: "Try Your Creative",
                href: "#try-your-creative",
                customScroll: true
            },
            {
                label: "Create Account",
                href: `/login/signup`,
                customScroll: false
            },
            {
                label: "Support",
                href: "https://support.lumimatrimony.com/hc/en-us",
                customScroll: false
            },
        ],
    },
    heroSection: {
        title: "Your Audience is Here.",
        subTitle: {
            content: "Reach Them with ",
            highlight: "Lumi Ads.",
        },
        description: "Grow your business on India’s fastest-growing matrimony app.",
        button: {
            title: 'Get Started',
            href: `/login/signup`
        },
        image: {
            url: bannerImage,
            alt: "mobile phone image",
        },
        decor: {
            url: bannerDecor,
            alt: "red decor image",
        },
        bottom_decor_image: {
            url: adsDecor,
            alt: "decor image",
        },
    },
    whatAreLumiAds: {
        id: "about-us",
        title: {
            content: "What are",
            highlight: "Lumi Ads?",
        },
        sub_title: "Whether you're a freelancer or a business, Lumi Ads makes it simple to connect, engage, and grow.",
        description: "Advertise your brand to the vast audience of India’s fastest-growing matrimony app, where couples and families plan their dream weddings. Showcase your business where it matters most, and take the next step in growing your brand with Lumi Ads.",
        image: {
            url: lumiAds,
            alt: "mobile image",
        },
    },
    whyLumiAds: {
        title: {
            content: "Why",
            highlight: "Lumi Ads?",
        },
        description: "Whether you're a freelancer or a business, Lumi Ads makes it simple to connect, engage, and grow. ",
        // "image": {
        //     "url": adsIcon5,
        //     "alt": 'icon'
        // },
        decorImage: {
            url: whyLumiAdsDecor,
            alt: "background image",
        },
        features: [{
                title: "Targeted Audience",
                description: "Connect with individuals who are actively planning weddings and related events, ensuring your ads reach the people who need your services.",
                image: {
                    url: adsIcon1,
                    alt: "icon",
                },
            },
            {
                title: "Flexible Plans",
                description: "Choose from a variety of advertising plans tailored to your budget and business goals, making it easy to find the right fit for your brand.",
                image: {
                    url: adsIcon2,
                    alt: "icon",
                },
            },
            {
                title: "Actionable Engagement",
                description: "Boost customer interactions with direct call-to-action options like Facebook, Instagram, WhatsApp, and more.",
                image: {
                    url: adsIcon3,
                    alt: "icon",
                },
            },
            {
                title: "Enhanced Visibility",
                description: "Showcase your portfolio, services, and catalogs directly within the app, giving your business the spotlight it deserves.",
                image: {
                    url: adsIcon4,
                    alt: "icon",
                },
            },
            {
                title: "Location Targeting",
                description: "Focus your campaigns by targeting customers in specific locations, ensuring your message reaches the right audience at the right time.",
                image: {
                    url: adsIcon5,
                    alt: "icon",
                },
            },
            {
                title: "Insightful Analytics",
                description: "Track your ad performance with a detailed dashboard featuring actionable insights and metrics, helping you optimize for success.",
                image: {
                    url: adsIcon6,
                    alt: "icon",
                },
            },
        ],
        id: "features",
        image: {
            url: laptopImage,
            alt: "laptop image",
        },
    },
    tryCreative: {
        id: "try-your-creative",
        bg_image: {
            url: bgImage,
            alt: "background image",
        },
        title: {
            content: "Try Your Creative Now!",
            highlight: "Creative",
        },
        description: "Try Your Creative Now! Or What Will It Look Like? Already have a creative? See how your ad will look when it goes live.",
        ctaText: "Update your Ad Banner",
        ctaNote: "Note: Resolution 1024x600, Maximum 5 Mb",
        images: [
            "creative-preview1.png",
            "creative-preview2.png",
            "creative-preview3.png",
        ],
    },
    footer: {
        contactForm: {
            placeholderName: "Name",
            placeholderEmail: "Email",
            buttonText: "Send",
        },
        navLinks: [{
                label: "Login",
                href: `/login/signin`
            },
            {
                label: "Create Account",
                href: `/login/signup`
            },
            {
                label: "Support",
                href: "https://support.lumimatrimony.com/hc/en-us",
            },
        ],
        // "links": ["Login", "Create Account", "About Us", "Support"],
        // "socialLinks": ["facebook.png", "instagram.png", "twitter.png", "youtube.png"],
        copyright: ` © ${new Date().getFullYear()} Fictitious Technologies (India) Private Limited. All rights reserved.`,
        privacy: {
            title: "Privacy",
            href: `/privacy`
        },
        terms: {
            title: "Terms",
            href: `/terms`
        },
    },
};